import { pathOr } from 'ramda';

import { IAgentSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { IState } from '../../store';

export const getAgent = (state: IState) => {
  return pathOr<IAgentSchema | null>(null, ['offerData', 'agent'], state);
};
